import { render, staticRenderFns } from "./_Settings.vue?vue&type=template&id=9caeffc6&scoped=true"
import script from "./_Settings.vue?vue&type=script&lang=js"
export * from "./_Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caeffc6",
  null
  
)

export default component.exports